import { SideBar } from './components/SideBar';

export const EditMyAccountMenu = () => {
  return <SideBar />;
};
